<template>
<div class="chapter">
<div class="inner_page">
<p class="title">Knocked for a Loop</p>
<p class="auth">A John J. Malone Mystery</p>
<p class="auth1">Craig Rice</p>
<div class="img_container1_n">
<img alt="image" src="images/logo3.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?16c6b144